var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.register)?_c('div',[_vm._v(_vm._s(_vm.$t('common.package'))+":"),_c('strong',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.register.Code))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }